// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root___DVvt","row":"ProcedureTreatmentSummary_row__2f82d"};